import { useState } from 'react';
import toast from 'react-hot-toast';
import { UserPlus } from 'lucide-react';
import { assignmentRequestsApi } from '../../lib/api';

export function RequestCoachButton({ personId, canRequest }: { personId: string; canRequest: boolean }) {
  const [open, setOpen] = useState(false);
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [requested, setRequested] = useState(false);

  if (!canRequest) return null;
  if (requested) return <span className="text-xs text-blast-700 dark:text-blast-300">Request sent — under review</span>;

  const submit = async () => {
    setSubmitting(true);
    try {
      await assignmentRequestsApi.create(personId, note || undefined);
      setRequested(true); setOpen(false);
      toast.success('Request sent to your manager');
    } catch (e) {
      const message = e && typeof e === 'object' && 'response' in e
        ? (e as { response?: { data?: { message?: string } } }).response?.data?.message
        : undefined;
      toast.error(message || 'Could not send request');
    } finally { setSubmitting(false); }
  };

  return (
    <>
      <button type="button" className="btn-secondary" onClick={() => setOpen(true)}>
        <UserPlus className="h-4 w-4 mr-1.5" /> Request this coach
      </button>
      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/40 p-4" onClick={() => setOpen(false)}>
          <div className="card w-full max-w-md p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
            <h3 className="font-semibold text-gray-900 dark:text-gray-100">Request this coach</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">Your manager will review and approve or deny.</p>
            <textarea className="input" rows={3} placeholder="Optional: why you want this coach…" value={note} onChange={(e) => setNote(e.target.value)} />
            <div className="flex justify-end gap-2">
              <button className="btn-secondary" onClick={() => setOpen(false)} disabled={submitting}>Cancel</button>
              <button className="btn-primary" onClick={submit} disabled={submitting}>{submitting ? 'Sending…' : 'Send request'}</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
